<div class="wrapper">
  <app-sidebar>
    <app-left-menu-list
      class="app-left-menu-list"
      [parentMenuId]="null"
    />
  </app-sidebar>

  <div
    class="main-content-wrapper"
    (click)="handleClickCloseSideBar()"
  >
    <router-outlet/>
  </div>
</div>


